import { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Globe } from '@/static';
import { memberCountByPropertyId, tryFetchMembers } from '@/slices/members';
import { tryFetchEvents, paginationByPropertyId } from '@/slices/events';
import { type RootState } from '@/store';

export const useSidebarItems = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { propertyId, eventId } = useParams();

  useEffect(() => {
    if (propertyId) {
      dispatch(tryFetchMembers({ propertyId }));
    }
  }, [dispatch, propertyId]);

  useEffect(() => {
    if (propertyId) {
      dispatch(tryFetchEvents({ propertyId, pagination: { page: 1 } }));
    }
  }, [dispatch, propertyId]);

  const memberCount = useSelector((state: RootState) =>
    propertyId ? memberCountByPropertyId(state, { propertyId }) : 0,
  );

  const pagination = useSelector((state: RootState) =>
    propertyId ? paginationByPropertyId(state, { propertyId }) : undefined,
  );

  const totalEvents = pagination?.total ?? 0;

  return useMemo(() => {
    const hiddenPaths = [`/events/${propertyId}/${eventId}`, '/me'];
    if (hiddenPaths.includes(pathname)) {
      return null;
    }

    const isEvents = pathname.startsWith('/events');
    const isProperties = pathname.startsWith('/properties');
    const isMembers = pathname.startsWith('/members');

    if ((isEvents || isMembers) && propertyId) {
      return [
        { path: `/events/${propertyId}`, label: `Events (${totalEvents})` },
        {
          path: `/members/${propertyId}`,
          label: `Manage Members (${memberCount})`,
        },
        // { path: '/', label: 'Edit Property' },
      ];
    }

    if (isProperties) {
      return [
        { path: '/properties', label: 'Property List', icon: <Globe /> },
        // { path: '/properties/add', label: 'Add Property', icon: <AddPlus /> },
      ];
    }

    return [
      { path: '/', label: 'Properties', icon: <Globe /> },
      // { path: '/add-property', label: 'Προσθήκη property', icon: <AddPlus /> },
    ];
  }, [pathname, propertyId, eventId, memberCount, totalEvents]);
};
